import { useQuery } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"
import ResponseError from "#/types/responseError"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"

export const CARROT_PLAN_REQUEST_STATUS_KEY = "getCarrotPlanRequestStatus"

export function useGetCarrotPlanRequestStatus() {
  return useQuery<CarrotPlanResponseStatus, ResponseError>(
    [CARROT_PLAN_REQUEST_STATUS_KEY],
    () => carrotClient.getCarrotPlanRequestStatus(),
    {
      retry: buildCarrotApiRetryPolicy(3)
    }
  )
}

export type CarrotPlanResponseStatus = {
  carrotPlanIsOnTheWay: boolean
  isPendingPostDoneForNowPlan: boolean
}
